import React from 'react';
import { Grid } from '@material-ui/core';
import { string } from 'prop-types';
import DefaultContainer from '../../DefaultContainer';
import styles from './style.module.scss';

const DoubleImage = ({
  imageLeft, imageRight,
}) => (
  <DefaultContainer>
    <Grid item xs={12} md={6} className={styles.imageLeft}>
      <img
        src={imageLeft}
        className={styles.envImg}
        alt="case environment"
      />
    </Grid>
    <Grid item xs={12} md={6} className={styles.imageRight}>
      <img
        src={imageRight}
        className={styles.envImg}
        alt="case environment"
      />
    </Grid>
  </DefaultContainer>
);

DoubleImage.propTypes = {
  imageLeft: string,
  imageRight: string,
};

DoubleImage.defaultProps = {
  imageLeft: null,
  imageRight: null,
};

export default DoubleImage;
